import '../../data/css/Speech.scss';
import {useEffect, useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {useGlobal} from "../../contexts/GlobalContext";
import {BeatLoader} from "react-spinners";
import {FaLaugh, FaPlay, FaStop} from "react-icons/fa";
import SpeechHint from "./SpeechHint";
import TellAJoke from "./TellAJoke";

function Speech() {
    const {result, setResult, setJokeActive, isMobile} = useGlobal()
    const [isSpeaking, setIsSpeaking] = useState(false);
    const [isTurnedOn, setIsTrunedOn] = useState(true)
    const [recognitionS, setRecognitionS] = useState()

    const onStart = () => {
        // console.log("Listening...")
        setIsSpeaking(true)
    }

    const turnOnOff = () => {
        setIsTrunedOn(!isTurnedOn)
    }


    const onResult = (event) => {
        const current = event.resultIndex;
        const transcript = event.results[current][0].transcript;
        setResult(transcript.toLowerCase())
        setIsSpeaking(false)
    }

    const startRecognition = (recognition) => {
        if (!isTurnedOn) return
        try {
            recognition.start();
        } catch (e) {
            // console.log("Already turned on!")
        }
    }

    const constantTurnOnListening = (recognition, time) => {
        setTimeout(function () {
            constantTurnOnListening(recognition, time)
            startRecognition(recognition)
        }, time);
    }


    const speech = () => {
        const speechRecogintion = window.webkitSpeechRecognition || window.SpeechRecognition
        const SpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList
        const SpeechRecognitionEvent = window.SpeechRecognitionEvent || window.webkitSpeechRecognitionEvent
        const colors = ['Menu', 'Close', 'Open', 'Github', 'About', 'Hide', 'Show', 'About', 'Hello'];
        const grammar = '#JSGF V1.0; grammar colors; public <color> = ' + colors.join(' | ') + ' ;'

        const recognition = new speechRecogintion()
        const speechRecognitionList = new SpeechGrammarList();
        speechRecognitionList.addFromString(grammar, 1);
        recognition.grammars = speechRecognitionList;
        recognition.continuous = true
        recognition.interimResults = true
        // recognition.grammars = ['heheszki', 'pogoda']
        recognition.lang = "en-US"
        recognition.onstart = onStart
        recognition.start();
        recognition.onsoundstart = () => setIsSpeaking(true)
        recognition.onaudiostart = () => setIsSpeaking(true)
        recognition.onresult = onResult
        setRecognitionS(recognition)

        console.log(recognition)
        constantTurnOnListening(recognition, 5000)
    }


    useEffect(() => {
        speech()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!recognitionS) return
        if (!isTurnedOn)
            recognitionS.stop();
        else startRecognition(recognitionS)
    }, [isTurnedOn]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>

            <nav className="speech-bar container-fluid aalp2">
                <div className="row w-100 pt-0">

                    <div className={"width-25"}></div>
                    <div className={"width-50"}>
                        {!isMobile && <>
                            {isTurnedOn && <h6 className={"mx-0 px-0 pr-2 d-inline"}>Voice Assistant: {result}</h6>}
                            {(isSpeaking && isTurnedOn) && <BeatLoader size={"10px"} color={"white"}/>}
                        </>
                        }
                    </div>

                    <div className={"width-10"}>
                        {!isMobile && <>
                            {isTurnedOn ?
                                <FaStop className={"cursor-pointer"} onClick={turnOnOff}/> :
                                <FaPlay className={"cursor-pointer"} onClick={turnOnOff}/>
                            }
                            <SpeechHint/>
                        </>}
                        <FaLaugh className={"cursor-pointer ml-3"} onClick={() => setJokeActive(1)}/>
                    </div>
                </div>
            </nav>
        </>


    );
}

export default Speech;
